import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth, routeAfterAuth } from "../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data);
        // Strip the hash and redirect
        window.history.replaceState(null, "", window.location.pathname);
        const next = sessionStorage.getItem("lif_after_login");
        sessionStorage.removeItem("lif_after_login");
        navigate(next || routeAfterAuth(data), { replace: true });
      } catch {
        navigate("/login?error=google_failed", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[var(--gold)] border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
        <p className="font-serif text-2xl text-[var(--ink)]">Locking you in…</p>
      </div>
    </div>
  );
}
